import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  useLoungeDirections,
  useLoungeTerminal,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

const LoungeLocationDetails = () => {
  const { loungeId } = useRouteParams();
  const terminal = useLoungeTerminal(loungeId);
  const directions = useLoungeDirections(loungeId);
  const { lounges } = useCommonContent();

  return (
    <div className="margin-3-b pad-3-b tw-border-b tw-border-gray-300">
      <h2 className="margin-1-b tw-heading-xs-bold tw-text-gray-900">
        {lounges?.location?.header}
      </h2>
      <div>
        {terminal} {directions && `(${directions})`}
      </div>
    </div>
  );
};

export default LoungeLocationDetails;
